<template>
  <div class="stationDetailPage">
      <div class="detail-top">
        <div class="station-name">
          {{ equmentdata.siteName }}
        </div>
        <div class="station-message">
          <span>负责人：{{ equmentdata.manager }}</span>
          <span class="station-phone">联系方式：{{ equmentdata.telephone }}</span>
          <span>信号强度：{{ equmentdata.signalStrength }}</span>
        </div>
        <div class="statin-btn">
          <div class="btn-item" @click="showList=true">
            导出数据
          </div>
          <div class="btn-item" @click="todetail()">
            监测管理
          </div>
        </div>
      </div>
      <div class="data-detail">

        <div class="analyes-title">
          数据详情
        </div>
        <div class="data-content">
          <div class="item-group">
            <span class="item-btn " :class="issave=='sssj'?'active-btn':''" @click="changesave('sssj')">
              瞬时数据
              <div class="blue-blank">

              </div>
            </span>
            <span class="item-btn " :class="issave=='djsj'?'active-btn':''" @click="changesave('djsj')">
              冻结数据
              <div class="blue-blank">

              </div>
            </span>
            <span v-show="isjfcs" class="item-btn " :class="issave=='jfcs'?'active-btn':''" @click="changesave('jfcs')">
              SupSENSOR参数
              <div class="blue-blank">

              </div>
            </span>

            <div class="gray-line">

            </div>
          </div>
          <div v-show="issave=='sssj'">
            <div class="item-unit">
              <span>电流：A</span>
              <span style="margin: 0 34px;">电压：v</span>
              <span>功率：w</span>
            </div>
            <div class="ssdata">
              <threedata v-if="isthree=='3'"/>
              <singledata v-if="isthree=='1'"/>
              <twodata v-if="isthree=='2'"/>
            </div>
            <div class="select-check">
                    <span class="time-select">
              <el-date-picker
                v-model="time"
                size="large"
                value-format="yyyy-MM-dd"
                style="width: 200px;"
                type="date"
                placeholder="开始时间"
              ></el-date-picker>
            </span>
              <el-checkbox-group v-model="checkList">
                <el-checkbox :label=item.param :key="item.param"  v-for="(item , index) in itemList" @change="checkitem(item,index)">
                  {{item.description}}
                </el-checkbox>

              </el-checkbox-group>


            </div>
            <div class="all-check">
              <div class="cavItem" v-for="item in activecon" :id="'leftcav'+item">

              </div>
            </div>
          </div>
          <div v-show="issave=='djsj'">

            <div class="table-con">
              <frozedata :sletime="sletime"/>
            </div>
          </div>
          <div v-show="issave=='jfcs' && isjfcs">

            <div class="table-con">
              <jfcsdata :sletime="sletime"/>
            </div>
          </div>
        </div>

      </div>
    <div class="risk-history" v-show="showList">
      <img class="close-X" src="../../assets/station/close.png" alt="" @click="showList=false">
      <div class="risk-history-title">
        导出数据
      </div>
      <div class="data-chose">
        <div>
          数据类型：<span>
          <el-radio v-model="datatype" label="1">实时数据</el-radio>
          <el-radio v-model="datatype" label="2">冻结时数据</el-radio>
          <el-radio v-model="datatype" label="3">冻结日数据</el-radio>
          <el-radio v-model="datatype" label="4">冻结月数据</el-radio>
        </span>
        </div>
        <div class="date-select">
          数据时段：
          <span v-show="datatype==1 || datatype==2 || datatype==3">
             <el-date-picker
               v-model="datastart"
               value-format="yyyy-MM-dd"
               size="large"
               style="width: 200px;"
               type="date"
               placeholder="开始时间"
             ></el-date-picker>
            -
            <el-date-picker
              style="width: 200px"
              size="large"
              v-model="dataend"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="结束时间"
            ></el-date-picker>
        </span>
          <span v-show="datatype==4">
             <el-date-picker
               v-model="datastart"
               value-format="yyyy-MM"
               size="large"
               style="width: 200px;"
               type="month"
               placeholder="开始时间"
             ></el-date-picker>
            -
            <el-date-picker
              style="width: 200px"
              size="large"
              v-model="dataend"
              value-format="yyyy-MM"
              type="month"
              placeholder="结束时间"
            ></el-date-picker>
        </span>
        </div>
        <div class="statin-btn">
          <div class="btn-item" @click="uploaddata()">
            确认
          </div>
          <div class="btn-cancel"  @click="showList=false">
            取消
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import qs from "qs";
import threedata from "../stationManagePage/components/threestationDetail";
import singledata from "../stationManagePage/components/singleDetail";
import frozedata from "../stationManagePage/components/frozedata";
import jfcsdata from "../stationManagePage/components/jfcsdata";
import twodata from "../stationManagePage/components/twoDetail";
import axios from "axios";


export default {
  name: "stationDetailPage",
  data() {
    return {
      issave:'sssj',
      sletime:"1",
      seltime:"",
      nowdata:[],
      checkList:[],
      titledata:[],
      itemList:[],
      tabledata:[],
      time:"",
      showList:"",
      datatype:"1",
      datastart:"",
      dataend:"",
      equmentdata:{},
      activedata:"",
      activecon:[0],
      cavdata:null,
      isthree:"3",
      cavtitle:null,
      isjfcs:false,

    };
  },
  methods: {
    gettoparr(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/processData/getIndexes"

      param.data={
        "monitorSiteId":this.saveid,
        // "monitorSiteId":12,

      }
      Axios.ajax(param).then((res)=>{


        if(res.resultCode=='0'){
            if(res.data.length){
              this.isjfcs=true
            }else{
              this.isjfcs=false
            }
        }else{

        }

      })
    },
    todetail(){
      Bus.$emit('pushrouter2', [this.equmentdata.siteName,this.equmentdata.branchId, this.saveid,"/stationDetail"])
    },
    uploaddata(){
      let url=''
      let text=''
    if(this.datatype==1 ){
      url='analogData/exportInstantParamData'
      text="瞬时数据"
    }else if(this.datatype==2){
      url='analogData/exportHourFreezeData'
      text="冻结时数据"
    }else if(this.datatype==3){
      url='analogData/exportDayFreezeData'
      text="冻结日数据"
    }else if(this.datatype==4){
      url='analogData/exportMonthFreezeData'
      text="冻结月数据"
    }
      this.queryparamdata(url,text)
    },
    queryparamdata(url,text) {
      let that = this;
      let param = {};
      param.url=url;
      if(this.datatype==4){
        param.params={
          monitorSiteId: this.saveid,
          startMonth: this.datastart,
          endMonth: this.dataend,
        }
      }else{
        param.params={
          monitorSiteId: this.saveid,
          startDate: this.datastart,
          endDate: this.dataend,
        }
      }

      axios({
        methods: 'get',
        url: this.baseUrl+param.url,
        params:param.params,
        responseType: 'blob'
      }).then((res)=>{
        const aLink = document.createElement("a");
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

        aLink.href = URL.createObjectURL(blob)

        aLink.download = text + '.xls'

        aLink.click()

        document.body.appendChild(aLink)



      })
    },
    checkitem(item,index){

      this.activecon=[]

      for(let i=0;i<this.checkList.length;i++){
        this.activecon.push(i)

        this.getcavdata( i,this.checkList[i].split(","),this.itemList[i].description)
      }
    },
    getcavdata(index,params,description){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/analogData/instantParamDataV2"

      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "params":params,
        "searchDate":this.time
      })
      Axios.ajax(param).then((res)=>{

        this.cavdata=[]
        if(res.resultCode=='0'){
          this.cavtitle=res.data[0]
          for(let i=1;i<res.data.length;i++){
            this.cavdata.push(res.data[i])
          }
          this.drewcav(this.cavtitle,this.cavdata,index,description)
        }else{

        }

      })
    },
    drewcav(title,data,index,description){

      let xdata=[]
      let series=[]
      let legend=[]

      let colorlist=['rgba(87,128,250,1)','#85f67a','#FFA940','#19AF23','#AAAF23','#00A9ee','#0011ee']
      for(let i=1;i<title.length;i++){
        let color=''

        if(title[i].indexOf('A相') != -1){
          color='rgb(0,128,0)'
        }else if(title[i].indexOf('B相') != -1){
          color='rgb(255,165,0)'
        }else if(title[i].indexOf('C相') != -1){
          color='rgb(255,0,0)'
        }else{
          color=colorlist[i-1]
        }
        // let yindex
        // if(title[i].indexOf('mA') != -1){
        //   yindex=1
        // }else{
        //   yindex=0
        // }
        series.push(
          {
            name: title[i],
            type: 'line',
            yAxisIndex:0,
            smooth:true,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: color
                }, {
                  offset: 1,
                  color: color
                }]),
                barBorderRadius: 11,

              }
            },
            data: []
          },
        )
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])

        for(let j=1;j<data[i].length;j++){
          series[j-1].data.push(data[i][j])
        }
      }

      let myChart =this.$echarts.init(document.getElementById('leftcav'+index));
      // myChart.clear()
      let option = {
        tooltip: {
          trigger: 'axis',
          confine:true,

          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data:legend
        },

        "dataZoom": [
          {
          "show": true,
          "height": 20,
          filterMode: 'filter',
          "xAxisIndex": [
            0
          ],
          bottom:'0',
          "start": 10,
          "end": 90,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle:{
            color:"#d3dee5",
          },
          textStyle:{
            color:"#000"
          },
          borderColor:"#90979c"
        },
          {
          "type": "inside",
          "show": true,
          "height": 20,
          "start": 1,
          "end": 35
        }],
        grid: {
          right: '2%',
          bottom: '20%',
          left: '5%',
          top: '20px',
          containLabel: false
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [
          {
          type: 'value',

          nameTextStyle: {

            color: '#000'
          },

          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },

          axisLabel: {
            // formatter: name => (`{name|${name}}`),
            // rich: {
            //   name: {
            //   width:'200%'
            //   },
            // },
            // formatter:(value) => {
            //   let newvalue=''
            //   console.log((value + '').length)
            //   switch ((value+'').length) {
            //     case 1:
            //       newvalue=value+' '+' '+' '+' '+' '
            //       break;
            //     case 2:
            //       newvalue=value+' '+' '+' '+' '
            //       break;
            //     case 3:
            //       newvalue=value+' '+' '+' '
            //       break;
            //     case 4:
            //       newvalue=value+' '+' '
            //       break;
            //     case 5:
            //       newvalue=value
            //       break;
            //     case 6:
            //       newvalue=value
            //       break;
            //   }
            //   console.log(newvalue)
            //   return newvalue;
            // },

            color: '#000',
            fontSize: 12,
          }
        },
          {
            type: 'value',

            nameTextStyle: {
              color: '#000'
            },
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },

            splitLine: {
              show:false,
              lineStyle: {
                color: "#0B4CA9",
              }

            },
            axisLabel: {
              color: '#000',
              fontSize: 12,
            }
          }
        ],
        series: series
      };
      myChart.setOption(option,true);
      myChart.on('click',(param)=>{
        console.log(param)
        console.log(description)
      })
      window.onresize = myChart.resize;
    },
    getparam() {
      let that = this;
      let param = {};
      param.method="post";
      param.url="/analogData/getParameterInfo";
      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "type":"Param",

      })
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.itemList=res.data
          for(let i = 0;i<res.data.length;i++){
            this.itemList[i].param=res.data[i].parameter.toString()
          }
          this.checkList=[this.itemList[0].param]
          console.log(this.itemList[0].description)
          this.getcavdata(0,this.itemList[0].parameter,this.itemList[0].description)
        }else{

        }

      })
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;
      var time = "";
      time =
        year + "-" + month + "-" + date ;

      this.time = time;
      this.year=year
      this.month=year + "-" + month
      this.hour=time

    },
    changesave(data){
      this.issave=data
    },
    getequmentlist(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitor/getMonitorSiteInfo";
      param.data=qs.stringify({
        monitorSiteId:this.saveid
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){

          this.equmentdata=res.data
          if(res.data.terminalTypeName=='YH-SMART1000S'){
            this.isthree="2"
          }else {
            if(res.data.terminalPhase=='1'){
              this.isthree="1"
            }
            else{
              this.isthree="3"
            }
          }
        }

      })
    },
    getmaintabledata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/analogData/instantParamDataV2";

      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "params":"",
        "searchDate":this.time

      })
      Axios.ajax(param).then((res)=>{

        this.tabledata=[]
        if(res.resultCode=='0'){
          this.titledata=res.data[0]
          for(let i=1;i<res.data.length;i++){
            this.tabledata.push(res.data[i])
          }
          this.activecon=[0]
          this.getparam()
        }else{

        }

      })
    },
  },
  mounted() {
    let that=this
    this.saveid=sessionStorage.getItem('saveid');
    this.getnowtime()
    this.getequmentlist()
    this.gettoparr()
    this.getmaintabledata()

  },
  watch: {
    time(){
      this.checkitem()
      // this.getmaintabledata()
    },
    datatype(){
      this.datastart=""
      this.dataend=""
    }
  },
  components: {
    threedata,
    singledata,
    frozedata,
    twodata,
    jfcsdata,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.stationDetailPage{
  position: relative;
  padding-bottom: 36px;
  .btn-item{
    display: inline-block;
    width: 80px;
    height: 40px;
    background: #2A62FF;
    border-radius: 4px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-left: 48px;
    cursor: pointer;
  }
  .detail-top{
    height: 120px;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 24px 0 0 36px;
    position: relative;
    .station-name{
      font-size: 16px;
      color: #2A62FF;
    }
    .station-message{
      margin-top: 24px;
      font-size: 14px;
      color: #7D879F;
    }
    .station-phone{
      margin:0 24px;
    }
    .statin-btn{
      position: absolute;
      right: 100px;
      bottom: 30px;
      .btn-item{
        display: inline-block;
        width: 80px;
        height: 40px;
        background: #2A62FF;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        margin-left: 48px;
        cursor: pointer;
      }
    }
  }
  .data-detail{
    position:relative;
    margin-top: 14px;
    background: #FFFFFF;
    border-radius: 4px;
  }

  .analyes-title{
    padding-left: 36px;
    height: 60px;
    line-height: 60px;
    color: #252B3C;
    font-size: 14px;
    border-bottom: 2px solid #F1F0F0;
  }
  .item-group{
    display:inline-block;
    cursor: pointer;
    .item-btn{
      font-size: 14px;
      color: #7D879F;
      margin-right: 36px;
      display: inline-block;
      z-index: 100;
      vertical-align: top;
      .blue-blank{
        width: 100%;
        margin-top: 12px;
        height: 2px;

      }

    }
    .item-btn:nth-last-child(2){
      margin-right: 10px;
    }
    .active-btn{
      color: #2A62FF;
      position: relative;
      .blue-blank{
        width: 100%;
        margin-top: 12px;
        height: 2px;
        background-color:  #2A62FF;

      }
    }
    .gray-line{
      height: 2px;
      border: 1px solid #F1F0F0;
      position: relative;
      top: -2px;
      z-index: 1;
    }
  }
  .data-content{
    padding: 28px 0 0 36px;
    position: relative;
  }
  .item-unit{
    position: absolute;
    right: 30px;
    top: 36px;
    font-size: 14px;

    color: #7D879F;
  }
  .ssdata{

    height: 250px;
    padding-right: 20px;
  }
  .select-check{
    position: relative;
    margin-top: 40px;

  }
  .time-select{
    position: absolute;
    top: -55px;
    right: 40px;
  }
  .all-check{
    min-height: 600px;
    overflow: auto;
    padding-bottom: 20px;
  }
  .table-font{

    width: 100%;
    td{
      text-align: center;
      height: 44px;

      border: 1px solid #ebeef5;
      font-size: 14px;
    }
    tr:nth-child(odd){
      background-color: rgb(245, 245, 245);
    }
    .fir-tr{
      background-color: rgb(245, 245, 245);
      color: rgb(0, 0, 0);
      font-weight: 500;


    }
  }
  .risk-history{
    width: 759px;
    height: 338px;
    background: #FFFFFF;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    position: absolute;
    top:calc(50% - 460px);
    right:  calc(50% - 380px);
    z-index: 10;
    .risk-history-title{
      text-align: center;
      color: #252B3C;
      font-size: 16px;
      height: 64px;
      line-height: 64px;
    }
    .close-X{
      position: absolute;
      top: 23px;
      right: 23px;
      cursor: pointer;
    }
    .search-blank{
      padding:11px 36px 0 36px;
    }
    .search-btn{
      width: 56px;
      height: 28px;
      background: #2A62FF;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      line-height: 28px;
      display:inline-block;
      margin: 0 12px;
      cursor: pointer;
    }
    .restart-btn{
      width: 56px;
      height: 28px;
      background: #fff;
      border-radius: 4px;
      color: #2A62FF;
      text-align: center;
      line-height: 28px;
      display:inline-block;
      border: 1px solid #2A62FF;
      cursor: pointer;
    }
    .data-chose{
      padding: 38px 0 0 65px;
    }
    .date-select{
      margin-top: 33px;
      height: 120px;
    }
    .statin-btn{
      float: right;
      margin-right: 65px;
      .btn-item{
        display: inline-block;
        width: 80px;
        height: 40px;
        background: #2A62FF;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;

        cursor: pointer;
      }
      .btn-cancel{
        display: inline-block;
        width: 80px;
        height: 40px;
        background: #fff;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        color: #2A62FF;
        border: 1px solid #2A62FF;
        font-size: 14px;
        margin-left: 12px;
        cursor: pointer;
      }
    }
  }

}
.cavItem{
  width: 96%;
  margin: 0 auto;
  height: 200px;
  margin-top: 20px;
}

</style>
